import { media } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { ConstrainedContainer } from '@atlassian/mpac-ui';
import { styled } from '@compiled/react';

export const Container = styled(ConstrainedContainer)({
  padding: '1.875rem 0',
  minHeight: '100vh',
  position: 'relative',
  [media.below.md]: {
    padding: token('space.200'),
  },
});

export const WarningContainerAfterHeader = styled.div({
  marginBottom: token('space.400'),
});

export const InfoContainerAfterHeader = styled.div({
  marginBottom: token('space.400'),
  maxWidth: '60%',
});
